// extracted by mini-css-extract-plugin
module.exports = {"titleError":"LikelyPossibilities_titleError__3nUeC","tile":"LikelyPossibilities_tile__1Q975"};